import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="fixed top-6 right-6 z-50 flex items-center bg-white/90 backdrop-blur-sm border-2 border-charcoal-900 shadow-lg" data-id="element-188">
      <button onClick={() => setLang('en')} className={`px-3 py-1.5 font-mono text-sm font-bold transition-colors ${lang === 'en' ? 'bg-charcoal-900 text-gold' : 'text-charcoal-900 hover:bg-charcoal-100'}`} data-id="element-189">
        EN
      </button>
      <div className="w-[2px] h-4 bg-charcoal-900" data-id="element-190" />
      <button onClick={() => setLang('fr')} className={`px-3 py-1.5 font-mono text-sm font-bold transition-colors ${lang === 'fr' ? 'bg-charcoal-900 text-gold' : 'text-charcoal-900 hover:bg-charcoal-100'}`} data-id="element-191">
        FR
      </button>
    </div>;
}